export default __webpack_public_path__ + "static/media/doc.54240355.svg";